import { Zap, PackageCheck, UserX } from "lucide-react";

export const FastReplierBadge = ({ testId, small }) => (
  <span data-testid={testId} className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-sky-400/90 font-extrabold text-[#0f2a33] ${small ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-0.5 text-xs"}`}>
    <Zap className={small ? "h-3 w-3" : "h-3.5 w-3.5"} /> Fast replier
  </span>
);

export const BuyerReliability = ({ stats, testId }) => {
  if (!stats) return null;
  const { pickups, no_shows: ns } = stats;
  return (
    <span data-testid={testId} className="inline-flex flex-wrap items-center gap-2 text-[11px]">
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-bold ${pickups ? "bg-[#d4f253] text-[#0f2a33]" : "bg-white/10 text-slate-300"}`}>
        <PackageCheck className="h-3 w-3" />{pickups ? `${pickups} completed pick-up${pickups > 1 ? "s" : ""}` : "New buyer"}
      </span>
      {ns > 0 && <span className="inline-flex items-center gap-1 rounded-full bg-red-500/80 px-2 py-0.5 font-bold text-white"><UserX className="h-3 w-3" />{ns} no-show{ns > 1 ? "s" : ""}</span>}
    </span>
  );
};
